import React, {useMemo} from 'react';
import {Props} from './ac-toaster-hoc.proptypes';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import clsx from 'clsx';

// Imports => Atoms
import {AcToaster} from '@asdf-atoms';

const _CLASSES = {
  MAIN: 'ac-toaster-hoc',
  TRANSITION: 'ac-toaster-transition',
};

const AcToasterHoc = ({queue, callback, ...rest}) => {
  const handleCallback = id => {
    if (callback) callback(id);
  };

  const getStyleClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  }, []);

  const renderToasts = useMemo(() => {
    if (!queue) return null;

    const len = queue.length;
    let n = 0;
    let result = [];

    for (n; n < len; n++) {
      const toast = queue[n];

      const object = (
        <CSSTransition
          classNames={_CLASSES.TRANSITION}
          timeout={{enter: 1000, exit: 1000}}
          key={`ac-toaster-${toast.id}`}
        >
          <AcToaster {...toast} callback={handleCallback} />
        </CSSTransition>
      );

      result.push(object);
    }

    return result;
  }, [queue]);

  return (
    <TransitionGroup className={getStyleClassNames} {...rest}>
      {renderToasts}
    </TransitionGroup>
  );
};

AcToasterHoc.displayName = 'AcToasterHoc';
AcToasterHoc.propTypes = Props;

export {AcToasterHoc};
export default AcToasterHoc;
